import { Box, Container, Typography } from "@mui/material";
import React from "react";
import CustomButton from "../CustomButton";
import { ChevronRightRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const OpportunitySection = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ width: "100vw", mb: { xs: 5 } }}>
      <Container
        sx={{
          /* height: { md: "100vh" }, */
          display: "flex",
          flexDirection: { xs: "column", md: "row-reverse" },
          justifyContent: "space-between",
          alignItems: "flex-start",
          textAlign: "center",
          pt: { xs: 5 },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "45%" },
            textAlign: "left",
          }}
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            The opportunities
          </Typography>
          <Typography variant="h2" sx={{ width: "100%", mb: "1rem" }}>
            The <span style={{ color: "#DB5430" }}>opportunities</span> we are{" "}
            <span style={{ color: "#DB5430" }}>providing</span>
          </Typography>
          <Typography>
            As someone said, “with great challenge comes great opportunity”. The
            immense need for high quality, holistic education and learning
            experiences across Africa is a problem EAGLE Learning has recognised
            and aims to address. With the rise of AI, many organizations aim to
            scale education at a rapid rate; however, what makes EAGLE’s
            approach unique is its vision to unlock the potential of individuals
            within communities by providing experiences and opportunities that
            an individual otherwise would never be able to experience.
          </Typography>
          <Box>
            <CustomButton
              sx={{ my: "1rem" }}
              onClick={() => navigate("/donate")}
            >
              <Typography>Journey with us</Typography>
              <ChevronRightRounded />
            </CustomButton>
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: "100%", md: "48%" },
            height: { xs: "50vh", md: "50vh" },
            backgroundColor: "#222222",
            borderRadius: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          <iframe
            className="video"
            width={"100%"}
            height={"100%"}
            src="https://www.youtube.com/embed/Q9fYp40k4qw?si=5ASy5iPQRkZXiZIY"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </Box>
      </Container>
    </Box>
  );
};

export default OpportunitySection;
